var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4316(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4316",
    "data-name": "Group 4316",
    transform: "translate(-125 -838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(125 838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M8,4.4A3.6,3.6,0,0,0,4.4,8V20A3.6,3.6,0,0,0,8,23.6H20A3.6,3.6,0,0,0,23.6,20V12.8a1.2,1.2,0,1,1,2.4,0V20a6,6,0,0,1-6,6H8a6,6,0,0,1-6-6V8A6,6,0,0,1,8,2h7.2a1.2,1.2,0,0,1,0,2.4Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M17.986,3.784a.716.716,0,0,0-.506.21l-7.025,7.025-.337,1.35,1.35-.337,7.025-7.025a.716.716,0,0,0-.506-1.222ZM16.219,2.732a2.5,2.5,0,1,1,3.535,3.535l-7.2,7.2a.892.892,0,0,1-.414.235l-3.031.758a.892.892,0,0,1-1.081-1.081l.758-3.031a.891.891,0,0,1,.235-.414Z",
    transform: "translate(3.515 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M15.261,5.261a.892.892,0,0,1,1.261,0l1.784,1.784a.892.892,0,1,1-1.261,1.261L15.261,6.522a.892.892,0,0,1,0-1.261Z",
    transform: "translate(1.602 -2.325)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4316);
export default __webpack_public_path__ + "static/media/Group 4316.2c18df6c01315c94c96d643af7289fab.svg";
export { ForwardRef as ReactComponent };